import type { FallbackProps } from 'react-error-boundary'
import { ErrorTemplate } from './ErrorTemplate'

export const GlobalErrorFallback = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <ErrorTemplate
      title='Something went wrong'
      description={message}
      resetErrorBoundary={resetErrorBoundary}
    />
  )
}
